/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type VistaprintProductQueryVariables = Types.Exact<{
    category?: Types.Maybe<Types.Scalars['String']>;
    locale: Types.Scalars['String'];
    externalId: Types.Scalars['String'];
    mpvId?: Types.Maybe<Types.Scalars['String']>;
}>;

export type VistaprintProductQuery = {
    __typename: 'Query';
    vistaprintProduct: {
        __typename: 'VistaprintProduct';
        vpProductKey: string;
        compatibleAttributes: Array<string>;
        currency: string;
        defaultQuantity: number;
        marketingImage: string;
        attributes: Array<{
            __typename: 'Attribute';
            key: string;
            name: string;
            summaryName: string;
            defaultValue: string;
            values: Array<{ __typename: 'AttributeValue'; key: string; name: string }>;
        }>;
    };
    printByExternalId: Types.Maybe<{
        __typename: 'Print';
        vpProductKey: string;
        id: string;
        options: Array<{ __typename: 'PrintOption'; key: string; value: string }>;
        estimatedPrice: Types.Maybe<{
            __typename: 'EstimatedPrice';
            currency: string;
            price: number;
            quantity: string;
        }>;
    }>;
};

export type PrintSummaryQueryVariables = Types.Exact<{
    externalId: Types.Scalars['String'];
}>;

export type PrintSummaryQuery = {
    __typename: 'Query';
    printSummary: Types.Maybe<{
        __typename: 'PrintSummary';
        id: string;
        externalReferenceId: string;
        options: Array<{
            __typename: 'PrintOption';
            key: string;
            keyName: string;
            value: string;
            valueName: string;
        }>;
    }>;
};

export type PrintByExternalIdQueryVariables = Types.Exact<{
    externalId: Types.Scalars['String'];
}>;

export type PrintByExternalIdQuery = {
    __typename: 'Query';
    printByExternalId: Types.Maybe<{
        __typename: 'Print';
        id: string;
        vpProductKey: string;
        templatePreview: string;
        options: Array<{
            __typename: 'PrintOption';
            key: string;
            keyName: string;
            value: string;
            valueName: string;
        }>;
    }>;
};

export type PrintTemplateQueryVariables = Types.Exact<{
    id: Types.Scalars['Int'];
}>;

export type PrintTemplateQuery = {
    __typename: 'Query';
    printById: {
        __typename: 'Print';
        id: string;
        template: { __typename: 'Template'; url: string; filename: string };
    };
};

export type ViewerQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ViewerQuery = {
    __typename: 'Query';
    me: { __typename: 'Viewer'; id: string; user: Types.Maybe<{ __typename: 'User'; id: string }> };
};

export type UpdateOrCreatePrintMutationVariables = Types.Exact<{
    input: Types.UpdateOrCreatePrintInput;
}>;

export type UpdateOrCreatePrintMutation = {
    __typename: 'Mutation';
    updateOrCreatePrint: {
        __typename: 'Print';
        id: string;
        vpProductKey: string;
        options: Array<{ __typename: 'PrintOption'; key: string; value: string }>;
        estimatedPrice: Types.Maybe<{
            __typename: 'EstimatedPrice';
            currency: string;
            price: number;
            quantity: string;
        }>;
    };
};

export const VistaprintProductDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'VistaprintProduct' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vistaprintProduct' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'category' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'category' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpvId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'vpProductKey' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summaryName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'values' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'key' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'defaultValue' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'compatibleAttributes' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'defaultQuantity' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'marketingImage' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'printByExternalId' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'externalId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'vpProductKey' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedPrice' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'price' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'quantity' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useVistaprintProductQuery__
 *
 * To run a query within a React component, call `useVistaprintProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useVistaprintProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVistaprintProductQuery({
 *   variables: {
 *      category: // value for 'category'
 *      locale: // value for 'locale'
 *      externalId: // value for 'externalId'
 *      mpvId: // value for 'mpvId'
 *   },
 * });
 */
export function useVistaprintProductQuery(
    baseOptions: Apollo.QueryHookOptions<VistaprintProductQuery, VistaprintProductQueryVariables>
) {
    return Apollo.useQuery<VistaprintProductQuery, VistaprintProductQueryVariables>(
        VistaprintProductDocument,
        baseOptions
    );
}
export function useVistaprintProductLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        VistaprintProductQuery,
        VistaprintProductQueryVariables
    >
) {
    return Apollo.useLazyQuery<VistaprintProductQuery, VistaprintProductQueryVariables>(
        VistaprintProductDocument,
        baseOptions
    );
}
export type VistaprintProductQueryHookResult = ReturnType<typeof useVistaprintProductQuery>;
export type VistaprintProductLazyQueryHookResult = ReturnType<typeof useVistaprintProductLazyQuery>;
export type VistaprintProductQueryResult = Apollo.QueryResult<
    VistaprintProductQuery,
    VistaprintProductQueryVariables
>;
export const PrintSummaryDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PrintSummary' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'printSummary' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'externalId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'externalReferenceId' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'keyName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'valueName' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePrintSummaryQuery__
 *
 * To run a query within a React component, call `usePrintSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintSummaryQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function usePrintSummaryQuery(
    baseOptions: Apollo.QueryHookOptions<PrintSummaryQuery, PrintSummaryQueryVariables>
) {
    return Apollo.useQuery<PrintSummaryQuery, PrintSummaryQueryVariables>(
        PrintSummaryDocument,
        baseOptions
    );
}
export function usePrintSummaryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PrintSummaryQuery, PrintSummaryQueryVariables>
) {
    return Apollo.useLazyQuery<PrintSummaryQuery, PrintSummaryQueryVariables>(
        PrintSummaryDocument,
        baseOptions
    );
}
export type PrintSummaryQueryHookResult = ReturnType<typeof usePrintSummaryQuery>;
export type PrintSummaryLazyQueryHookResult = ReturnType<typeof usePrintSummaryLazyQuery>;
export type PrintSummaryQueryResult = Apollo.QueryResult<
    PrintSummaryQuery,
    PrintSummaryQueryVariables
>;
export const PrintByExternalIdDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PrintByExternalId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'printByExternalId' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'externalId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vpProductKey' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'keyName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'valueName' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'templatePreview' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePrintByExternalIdQuery__
 *
 * To run a query within a React component, call `usePrintByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintByExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function usePrintByExternalIdQuery(
    baseOptions: Apollo.QueryHookOptions<PrintByExternalIdQuery, PrintByExternalIdQueryVariables>
) {
    return Apollo.useQuery<PrintByExternalIdQuery, PrintByExternalIdQueryVariables>(
        PrintByExternalIdDocument,
        baseOptions
    );
}
export function usePrintByExternalIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PrintByExternalIdQuery,
        PrintByExternalIdQueryVariables
    >
) {
    return Apollo.useLazyQuery<PrintByExternalIdQuery, PrintByExternalIdQueryVariables>(
        PrintByExternalIdDocument,
        baseOptions
    );
}
export type PrintByExternalIdQueryHookResult = ReturnType<typeof usePrintByExternalIdQuery>;
export type PrintByExternalIdLazyQueryHookResult = ReturnType<typeof usePrintByExternalIdLazyQuery>;
export type PrintByExternalIdQueryResult = Apollo.QueryResult<
    PrintByExternalIdQuery,
    PrintByExternalIdQueryVariables
>;
export const PrintTemplateDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PrintTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'printById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'template' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'filename' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePrintTemplateQuery__
 *
 * To run a query within a React component, call `usePrintTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrintTemplateQuery(
    baseOptions: Apollo.QueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>
) {
    return Apollo.useQuery<PrintTemplateQuery, PrintTemplateQueryVariables>(
        PrintTemplateDocument,
        baseOptions
    );
}
export function usePrintTemplateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>
) {
    return Apollo.useLazyQuery<PrintTemplateQuery, PrintTemplateQueryVariables>(
        PrintTemplateDocument,
        baseOptions
    );
}
export type PrintTemplateQueryHookResult = ReturnType<typeof usePrintTemplateQuery>;
export type PrintTemplateLazyQueryHookResult = ReturnType<typeof usePrintTemplateLazyQuery>;
export type PrintTemplateQueryResult = Apollo.QueryResult<
    PrintTemplateQuery,
    PrintTemplateQueryVariables
>;
export const ViewerDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Viewer' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(
    baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>
) {
    return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, baseOptions);
}
export function useViewerLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>
) {
    return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, baseOptions);
}
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const UpdateOrCreatePrintDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateOrCreatePrint' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'UpdateOrCreatePrintInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateOrCreatePrint' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vpProductKey' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedPrice' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'price' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'quantity' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type UpdateOrCreatePrintMutationFn = Apollo.MutationFunction<
    UpdateOrCreatePrintMutation,
    UpdateOrCreatePrintMutationVariables
>;

/**
 * __useUpdateOrCreatePrintMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreatePrintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreatePrintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreatePrintMutation, { data, loading, error }] = useUpdateOrCreatePrintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreatePrintMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateOrCreatePrintMutation,
        UpdateOrCreatePrintMutationVariables
    >
) {
    return Apollo.useMutation<UpdateOrCreatePrintMutation, UpdateOrCreatePrintMutationVariables>(
        UpdateOrCreatePrintDocument,
        baseOptions
    );
}
export type UpdateOrCreatePrintMutationHookResult = ReturnType<
    typeof useUpdateOrCreatePrintMutation
>;
export type UpdateOrCreatePrintMutationResult = Apollo.MutationResult<UpdateOrCreatePrintMutation>;
export type UpdateOrCreatePrintMutationOptions = Apollo.BaseMutationOptions<
    UpdateOrCreatePrintMutation,
    UpdateOrCreatePrintMutationVariables
>;
